/**
 * @generated SignedSource<<94a012cadd441203c8d2c31f966162e3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags$data = {
  readonly totalCount: number;
  readonly " $fragmentType": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags";
};
export type multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags$key = {
  readonly " $data"?: multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags$data;
  readonly " $fragmentSpreads": FragmentRefs<"multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "multipleFlags_softwareReleasesVersionDetailIssueList_summarisedFlags",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "totalCount"
      },
      "action": "THROW",
      "path": "totalCount"
    }
  ],
  "type": "DevOpsSummarisedFeatureFlags"
};

(node as any).hash = "f8750caf47e7cdb0f524b2138f711e5d";

export default node;
